define(['jquery'], function ($) {

  $.fn.pkoRadio = function (_options) {

    var options = $.extend({}, $.fn.pkoRadio.defaults, _options);

    var init = function (elem) {
      var $elem = $(elem);

      if ($elem.prev().length < 1 && !$elem.prev().hasClass(options.classRadio)) {
        $elem.before('<span class="' + options.classRadio + '"></span>');
      }

      $elem.addClass(options.classInput);

      isChecked($elem, true);
    };

    var events = function (elem) {
      var $elem = $(elem);

      $elem.on('click', function () {
        isChecked($elem);
      });

      // $elem.on( 'focus', function( ) {
      //     $( this ).prev( 'span.' + options.classRadio ).addClass( 'focus' );// 2DO
      // } );

      // $elem.on( 'blur', function( ) {
      //     $( this ).prev( 'span.' + options.classRadio ).removeClass( 'focus' );// 2DO
      // } );

      $elem.on('switch.check', function (event, mode) {
        if (mode === undefined) {
          mode = true;
        }
        $elem.prop('checked', mode);
        if (mode) {
          $elem.prev('.' + options.classCheckbox).addClass('checked');
        } else {
          $elem.prev('.' + options.classCheckbox).removeClass('checked');
        }
      });
    };

    var isChecked = function (_this, initial) {
      if (initial === undefined) {
        /*
         * jezeli isChecked jest wywolane przez init to zaden widget nie jest zaznaczony
         * nie mozemy jednak ich odznaczac bo ta funkcja jest wywolana dla kazdego checkboxa
         * na stronie o powoduje odznaczenie poprzednich. a przeciez jeden z nich mogl
         * byc zaznaczony poniewaz analogicznie input w formie jest domyslnie zaznaczony.
         * Zakladamy ze w formularzy tylko jedno radio jest zaznaczone i nie ma sytuacji
         * niestandardowych.
         */
        $('input[type="radio"]').filter('[name="' + _this.attr('name') + '"]').each(function () {
          $(this).prev('.' + options.classRadio).removeClass('checked');
        });
      }

      if (_this.is(':checked')) {
        _this.prev('.' + options.classRadio).addClass('checked');
      }

      // if ( _this.is( ':disabled' ) ) {
      //     _this.prev( '.' + options.classRadio ).addClass( 'disabled' );// 2DO
      // } else {
      //     _this.prev( '.' + options.classRadio ).removeClass( 'disabled' );// 2DO
      // }
    };

    return this.each(function () {
      init(this);
      events(this);
    });

  };

  $.fn.pkoRadio.defaults = {
    classRadio: 'form-radio',
    classInput: 'form-radio-input'
  };

});



// WEBPACK FOOTER //
// ./_front/_inteligo/js/lib/jquery.pkoRadio.js